import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ClientEntity } from './client.entity';

/**
 * Sales visit record — when a salesperson visits a client. Despite the
 * `m_sm_` prefix (legacy SM1 carryover) this is an actively-used CRM
 * entity in both the new app (`clients.service.ts:createVisit`,
 * scorecard reports, goals reports, AI agent tools) AND the old app
 * (`~/development/supplymover/src/service/client-visit.service.ts`).
 *
 * Distribution refactor history: Rafi previously added 9 routing/delivery
 * columns to this table (`m_sm_fk_route_stop__id`,
 * `m_sm_fk_execution__id`, `m_sm_sequence`, `m_sm_visit_status`,
 * `m_sm_delivery_failure_reason`, `m_sm_proof_signature`,
 * `m_sm_proof_photo`, `m_sm_actual_arrival`, `m_sm_actual_departure`)
 * and the routes module created visit rows on delivery-stop completion
 * — conflating sales visits with delivery stops. All those columns are
 * dropped; delivery completion data lives natively on `trip_stop` now.
 */
@Entity('m_sm_client_visit')
@Index('ix_client_user', ['clientId', 'workdUserId'])
export class ClientVisitEntity extends BaseEntity {
	@Column({ name: 'm_sm_fk_client__id', type: 'int', unsigned: true })
	public clientId!: number;

	@Column({ name: 'm_sm_workdUserId', type: 'int', unsigned: true })
	public workdUserId!: number;

	@Column({ name: 'm_sm_date', type: 'datetime', nullable: true })
	public date?: Date;

	@Column({
		name: 'm_sm_latitude',
		type: 'decimal',
		precision: 10,
		scale: 8,
		nullable: true,
	})
	public latitude?: number | null;

	@Column({
		name: 'm_sm_longitude',
		type: 'decimal',
		precision: 11,
		scale: 8,
		nullable: true,
	})
	public longitude?: number | null;

	@ManyToOne(() => ClientEntity, (client) => client.clientVisits)
	@JoinColumn({ name: 'm_sm_fk_client__id' })
	public fkClient!: ClientEntity;
}
